import * as React from "react";
import { withStyles, WithStyles, createStyles, TextField, InputAdornment } from "../../../node_modules/@material-ui/core";
import { InputProps } from "../../types/InputProps";
import CalendarIcon from "../Icons/CalendarIcon";

const styles = () => createStyles({
    icon: {
        opacity: 0.6
    }
});

class InputDate extends React.Component<InputProps & WithStyles<typeof styles>, { opacity: number }> {

    state = {
        opacity: this.props.value ? 1 : 0
    };

    public render() {

        const { theme, classes } = this.props;

        return (
            <TextField
                className={"InputDate"}
                disabled={this.props.disabled} 
                type="date"
                label={this.props.label ? this.props.label : null}
                placeholder={this.props.placeholder ? this.props.placeholder : null}
                value={this.props.value ? this.props.value : ""}
                error={this.props.error ? this.props.error : false}
                style={{ width: "100%" }}
                onChange={event => 
                    this.onChange(event.target.value, event.target)
                }
                helperText={this.props.legend ? this.props.legend : ""}
                InputLabelProps={{
                    shrink: true,
                }}     
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" className={classes.icon}>
                            <CalendarIcon nativeColor={theme.palette.primary.main} />
                        </InputAdornment>
                    )
                }}
                required={this.props.required}
                inputProps={{
                    ...this.props.dateProps,
                    /*
                    style: {
                        opacity: this.state.opacity
                    },
                    onBlur: (event) => {
                        if (event.target.value) {
                            event.target.reportValidity();
                        } else {
                            this.setState({
                                opacity: 0
                            });
                        }
                    },            
                    onFocus: (event) => {
                        this.setState({
                            opacity: 1
                        });
                    }
                    */
                }}
            />
        );
    }

    private onChange(reponse: any, element: any) {
        this.props.onChange(reponse, element);
    }
}

export default withStyles(styles, {withTheme: true})(InputDate);



// WEBPACK FOOTER //
// ./src/components/InputDate/InputDate.tsx